/*
	s_scroll.js
*/

function scrollToDefaultPos() {
    if(window.currentPageType == window.PAGE_TYPE_INSTRUMENTS) {
    } else {
        $(window).scrollTop(0);
    }
}

function resetScroll() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
}


function refreshScroll() {
    window.scrollTop = $(document).scrollTop();
    refreshCursor();
    refreshMenu();
    if(window.currentPageType == window.PAGE_TYPE_INSTRUMENTS && window.scrollTop > 0) {
        refreshInstrumentCircle();
        // refreshParallax();
        if(!isFirefox)
            refreshVideo();
        
    } else if(window.currentPage == window.PAGE_ABOUT || window.currentPage == window.PAGE_CART) {
        refreshAboutCircle();
    } 

    window.requestAnimationFrame(refreshScroll);
}

function setupScroll() {
    scrollPos = $(document).scrollTop();
    window.requestAnimationFrame(refreshScroll);
}

window.addEventListener("DOMContentLoaded", setupScroll);



$(document).ready(function(){
    window.setTimeout(scrollToDefaultPos, 100);
    window.scrollTop = $(document).scrollTop();
    $(window).scroll(function(){
        easeScrolling = true;
        scrollTop = window.scrollTop;

        /*if(window.currentPage == window.PAGE_PIANO && instrumentVideoIsPlaying && scrollTop > 200 && !instrumentVideoClicked) {
            stopInstrumentVideo();
        }*/
        previousScroll = window.scrollTop;
        
    });
});